export enum NoteType {
    ActivityWaitlist = 0,
    Relation = 1,
}

export const NoteTypeIdNames: Record<number, string> = {
    [NoteType.ActivityWaitlist]: "activityId",
    [NoteType.Relation]: "relationId",
  }